._wrapper_xqjh6_1 {
  width: 560px;
  height: 132px; }
  ._wrapper_opt_xqjh6_4 {
    width: 329px;
    height: 101px; }

._illustration_xqjh6_8 {
  width: 96px; }
